export default "__VITE_ASSET__BTGmqtKD__"